import {ENDPOINT_OBLIGATION} from 'common/endpoints';
import {commonJwtHeader} from 'common/utils';

const callGetObligationByGrantId = ({grantId}) => {
  return getObligationByGrantId(grantId);
};

const callGetAllObligationsByGrantId = ({grantId}) => {
  return getAllObligationsByGrantId(grantId);
};

const getObligationByGrantId = (grantId) => {
  const endpointToUse = `${ENDPOINT_OBLIGATION}availableObligations?grantId=${grantId}`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const getAllObligationsByGrantId = (grantId) => {
  const endpointToUse = `${ENDPOINT_OBLIGATION}find?grantId=${grantId}`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const callGetObligationBySubGrants = ({subGrants}) => {
  return Promise.all(
    subGrants.map((subGrant) => getAllObligationsByGrantId(subGrant.grantId))
  );
};

const getSubGrantTotalObligationAmountsByGrantId = (grantId) => {
  const endpointToUse = `${ENDPOINT_OBLIGATION}totalObligationAmounts/subGrants/${grantId}`;

  return fetch(endpointToUse, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

const callGetSubGrantTotalObligationAmountsForGrantIds = ({grantIds}) => {
  return Promise.all(
    grantIds.map((grantId) => getSubGrantTotalObligationAmountsByGrantId(grantId))
  );
};

//used through listener config when loading returnOfFund request page in UI
const isReturnOfFundsRequestValid = ({entityId, entityType, rofAmount}) => {
  let id = entityType === 'grant' ? `grantId` : `subGrantId`;
  const endpoint = `${ENDPOINT_OBLIGATION}returnOfFunds/validate?${id}=${entityId}&returnOfFundsAmount=${rofAmount}`;
  return fetch(endpoint, {
    method: 'GET',
    headers: commonJwtHeader(),
  });
};

export default {
  callGetObligationByGrantId,
  getObligationByGrantId,
  callGetObligationBySubGrants,
  callGetAllObligationsByGrantId,
  getAllObligationsByGrantId,
  getSubGrantTotalObligationAmountsByGrantId,
  callGetSubGrantTotalObligationAmountsForGrantIds,
  isReturnOfFundsRequestValid,
};
